// 宣言
declare const Swiper;

const $BP_L = 1024; // PC
const $BP_M = 768;  // TB
const $BP_S = 480;  // SP

const currentWidth = $(window).width();

var activeClass = 'js-active';



// メニュー
function initMenu() {
    var $menuBtn = $('.js-menu-toggle'),
        $searchBtn = $('.js-search-toggle');
    var $nav = $('.js-nav'),
        $defaultNav = $('.js-default-nav'),
        $searchNav = $('.js-search-nav');
    var $header = $('.js-header');

    function toggleMenu() {
        $nav.toggleClass(activeClass);
        $header.toggleClass(activeClass);
    }

    $menuBtn.click(function () {
        $menuBtn.toggleClass(activeClass);
        $defaultNav.addClass(activeClass);
        $searchNav.removeClass(activeClass);

        if ($searchBtn.hasClass(activeClass)) {
            $searchBtn.removeClass(activeClass);
        } else {
            toggleMenu();
        }
    });

    $searchBtn.click(function () {
        $searchBtn.toggleClass(activeClass);
        $defaultNav.removeClass(activeClass);
        $searchNav.addClass(activeClass);

        if ($menuBtn.hasClass(activeClass)) {
            $menuBtn.removeClass(activeClass);
        } else {
            toggleMenu();
        }
    });
}

// アコーディオン
function initAccordion() {
    $('.js-accordion').aemAccordion({
        openHash: true
    });
}

// タブ、セレクト切り替え
function initTab() {
    var $tabWrap = $('.tab-wrap');

    $tabWrap.each(function () {
        var $tabTitle = $(this).find('.tab-category li'),
            $tabTitlesp = $(this).find('.tab-select'),
            $tabBody = $(this).find('.tab-list__area'),
            activeClass = 'active';


        $tabTitle.click(function () {
            var index = $tabTitle.index(this);
            $tabTitle.removeClass(activeClass);
            $(this).addClass(activeClass);
            $tabBody.removeClass(activeClass).eq(index).addClass(activeClass);
        });

        $tabTitlesp.change(function () {
            var indexsp = $tabTitlesp.prop('selectedIndex');
            $tabBody.hide();
            $tabBody.removeClass(activeClass).eq(indexsp).addClass(activeClass).fadeIn();
        });
    });
}

// inview
function initInview() {
    $('.js-inview').aemInview({
        // offset: '5%',
        // test: 'aqua',
        scrollEnd: true,
    });
}

$(function () {
    $('.aem-post').find('img').wrap('<span class="js-protect"></span>');

    $('.aem-post').find('iframe').wrap('<div class="movie-wrapper"></div>');

    $('.aem-post').find('table').wrap('<div class="table-wrapper"></div>');

    $('.js-protect').aemProtectImage({
        blankImg: '/images/blank.gif'
    });

    $('a[href^="#"]').not('.no-scroll').aemSmoothScroll();

    $('[data-fancybox]').fancybox({
        protect: true,
        loop: true,
        toolbar: true,
        smallBtn: false,
        buttons: [
            "close"
        ],
        baseTpl:
        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
                '<div class="fancybox-infobar"><span class="fancybox-infobar__pagination-current" data-fancybox-index></span><div class="fancybox-infobar__bar"><span class="bar"></span></div><span class="fancybox-infobar__pagination-total" data-fancybox-count></span></div>' +
                '<div class="fancybox-toolbar">{{buttons}}</div>' +
                '<div class="fancybox-navigation">{{arrows}}</div>' +
                '<div class="fancybox-stage"></div>' +
                '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
            '</div>' +
        '</div>',
        afterShow: function (instance, current) {
            $('.fancybox-infobar__bar').each(function () {
                $(this).css('--current' , current.index + 1);
                $(this).css('--total' , instance.group.length);
            });
        }
    });

    initMenu();
    initAccordion();
    initTab();
    initInview();
})

var $scrollTarget = $('.js-scroll');
var $pagetop = $('.js-pagetop');
var $footer = $('.footer');

$('.select__item').on('change',function(){
    let currentSelect =  convertSelect($(this));
});
function convertSelect(currentSelect){
    //console.log(currentSelect.val());
    if(currentSelect.val()){
        currentSelect.parents('form').find('#button .button').prop('disabled', false);
    }
    else {
        currentSelect.parents('form').find('#button .button').prop('disabled', true);
    }
}

$(window).on('scroll', function () {
    if ($scrollTarget.length) {
        $scrollTarget.each(function () {
            var storeLinkTopPosition = $(this).offset().top,
                storeLinkHeight = $(this).innerHeight(),
                storeLinkBottomPosition = storeLinkTopPosition + storeLinkHeight;
            var footerTopPosition = $footer.offset().top;

            if (storeLinkBottomPosition >= footerTopPosition) {
                $(this).removeClass(activeClass);
            } else {
                // 少しでもスクロールしていたらpagetopボタン表示
                if ($(window).scrollTop() > 0) {
                    $(this).addClass(activeClass);
                } else {
                    $(this).removeClass(activeClass);
                }
            }
        });
    }

    // 少しでもスクロールしていたらpagetopボタン表示
    if ($(window).scrollTop() > 0) {
        $pagetop.addClass(activeClass);
    } else {
        $pagetop.removeClass(activeClass);
    }
});

$(".js-pagetop").on("click",function () {
    $('html, body').animate({
        scrollTop: 0
    }, 300);
});

// .submit_formの値が変わると自動的にSubmitさせる
$(".submit_form").on("change",function(currentInput){
    submitForm($(this)[0].form);
})
function submitForm(currentForm){
    currentForm.submit();
}
// 検索カテゴリクリック時のモーダル
convertSelectMenu();
function convertSelectMenu() {
    var $select = $('.js-select-menu');
    $select.each(function () {
        var _this = $(this);
        var selectedValue;
        var selectedHtml;
        _this.append('<dl class="menu-accordion js-accordion">'
            + '<div>'
            + '<dt class="menu-accordion__title js-accordion-title"></dt>'
            + '<dd class="menu-accordion__body js-accordion-body">'
            + '<span class=\"js-accordion-close\"><span class="js-accordion-close__button">×</span></span>'
            + '<ul class="search-menu"></ul>'
            + '</dd>'
            + '</div>'
            + '</dl>');

        selectedValue = _this.find('option').first().val();
        selectedHtml = _this.find('option[selected]').first().html();
        _this.find('.js-accordion-title').text(selectedHtml);
        if (_this.find('optgroup').length) {
            var firstValue = $(this).find('option').first().val();
            var firstHTML = $(this).find('option').first().html();
            _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item\" data-value=\"" + firstValue + "\">\n                        <div class=\"search-menu__inner search-menu__link\"><span>" + firstHTML + "</span></div>\n                    </li>");

            _this.find('optgroup').each(function () {
                var groupFirstValue = $(this).find('option').first().val();
                var groupFirstHTML = $(this).find('option').first().html();
                var list = '';
                $(this).find('option').each(function (index) {
                    if (index !== 0) {
                        var newValue = $(this).val();
                        var newHTML = $(this).html();
                        var is_none = $(this).prop('disabled');
                        if (is_none) {
                            return;
                        }
                        list = list + '<li class="search-menu__item" data-value="' + newValue + '"><div class="search-menu__inner search-menu__link"><span>' + newHTML + '</span></div></li>';
                    }
                });
                _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item\" data-value=\"" + groupFirstValue + "\">\n                            <div class=\"search-menu__inner search-menu__link\"><span>" + groupFirstHTML + "</span></div>\n                            <ul class=\"search-menu\">" + list + "</ul>\n                        </li>");
            });
        }
        else {
            _this.find('option').each(function () {
                var newValue = $(this).val();
                var newHTML = $(this).html();
                var is_none = $(this).prop('disabled');
                if (is_none) {
                    return;
                }
                _this.find('.js-accordion-body .search-menu').append('<li class="search-menu__item" data-value="' + newValue + '"><div class="search-menu__inner search-menu__link"><span>' + newHTML + '</span></div></li>');
            });
        }
        _this.find('.search-menu__item').each(function () {
            var selected = $(this).parents('.js-accordion-body').prev('.js-accordion-title').text();
            var value = $(this).text();
            if (selected == value) {
                $(this).addClass('js-selected');
            }
        });
        _this.find('.search-menu__inner').click(function () {
            var newValue = $(this).parent().data('value');
            $(this).parents('.js-accordion-body').prev('.js-accordion-title').text($(this).text());
            $(this).parents('.js-accordion-body').prev('.js-accordion-title').trigger('click');
            _this.find('.search-menu__inner').removeClass('js-selected');
            $(this).addClass('js-selected');
            _this.find('option[selected]').removeAttr('selected');
            _this.find('option[value="' + newValue + '"]').attr('selected', '');
            submitForm($(".submit_form")[0].form);
        });
    });
}
// 検索モーダルを閉じたら、カテゴリなどのアコーディオンも閉じる。
$(".js-accordion-close").on("click",function(){
    closeSearchAccordion();
});
$(".js-search-toggle").on("click",function(){
    closeSearchAccordion();
});
function closeSearchAccordion(){
    $(".js-accordion-title,.js-accordion-body").removeClass('js-open');
    $(".js-accordion-body").removeAttr('style');
}